/**
 * @generated SignedSource<<4d24ace556ae0bf2a34dc32f40691ed2>>
 * @relayHash 5c2e3606f14a34254e5ce33b28e3db7a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 03069933668c02ea6398afdd93d705f403e4a357bc38452dcf81b1596e91ff36

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamsTeamLayoutQuery$variables = {
  account: string;
  team: string;
};
export type teamsTeamLayoutQuery$data = {
  readonly accountBySlug: {
    readonly __typename: "Organization";
    readonly " $fragmentSpreads": FragmentRefs<"tabsNavigationContainerBreadcrumbsFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly teamBySlug: {
    readonly " $fragmentSpreads": FragmentRefs<"tabsNavigationContainerTeamFragment">;
  } | null | undefined;
};
export type teamsTeamLayoutQuery = {
  response: teamsTeamLayoutQuery$data;
  variables: teamsTeamLayoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "team"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "organizationSlug",
    "variableName": "account"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "team"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "account"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "teamsTeamLayoutQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamBySlug",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "tabsNavigationContainerTeamFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "tabsNavigationContainerBreadcrumbsFragment"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "teamsTeamLayoutQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamBySlug",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamConnection",
                            "kind": "LinkedField",
                            "name": "subteams",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5c2e3606f14a34254e5ce33b28e3db7a",
    "id": "03069933668c02ea6398afdd93d705f403e4a357bc38452dcf81b1596e91ff36",
    "metadata": {},
    "name": "teamsTeamLayoutQuery",
    "operationKind": "query",
    "text": "query teamsTeamLayoutQuery(\n  $account: String!\n  $team: String!\n) {\n  teamBySlug(organizationSlug: $account, slug: $team) {\n    ...tabsNavigationContainerTeamFragment\n    id\n  }\n  accountBySlug(slug: $account) {\n    __typename\n    ... on Organization {\n      ...tabsNavigationContainerBreadcrumbsFragment\n    }\n    id\n  }\n}\n\nfragment helpersGetTeamsTreeFragment on Organization {\n  teams {\n    edges {\n      node {\n        id\n        slug\n        name\n        subteams {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment tabsNavigationContainerBreadcrumbsFragment on Organization {\n  ...teamBreadcrumbsFragment\n}\n\nfragment tabsNavigationContainerTeamFragment on Team {\n  id\n  name\n  slug\n}\n\nfragment teamBreadcrumbsFragment on Organization {\n  ...helpersGetTeamsTreeFragment\n}\n"
  }
};
})();

(node as any).hash = "1db884789ef46397423d6bb8c1b8eef3";

export default node;
